import { EProductClassification } from "../api/Types";

export const SwyftContactPhoneNumberLink = "tel:+35315042111";
export const SwyftContactCorkPhoneNumberLink = "tel:+353217011238";
export const SwyftContactCorkPhoneNumber = "(021) 701 1238";
export const SwyftContactDublinPhoneNumberLink = SwyftContactPhoneNumberLink;
export const SwyftContactDublinPhoneNumber = "(01) 504 2111";
export const SwyftContactPhoneNumberWhatsAppLink = "https://wa.me/353212040057";
export const SwyftEmailLink = "mailto:hi@swyftenergy.ie";
export const SwyftEmail = "hi@swyftenergy.ie";

export const PermissionQuoteRead = "quote:read";
export const PermissionQuoteWrite = "quote:write";
export const PermissionQuoteLineItemWrite = "quote.lineitem:write";
export const PermissionQuoteApprovedLineItemWrite = "quote.approved.lineitem:write";
export const PermissionDiscountWrite = "quote.discount:write";
export const PermissionAdminWrite = "admin:write";

export const BasePath = "/store";

const CookiePrefix = "swyft.store";
export const CookieQuoteId = `${CookiePrefix}.quoteId`;

export const AdditionalItemsCode = "B9999";
export const BoilerVatRate = 13.5;
export const SolarVatRate = 0;
export const SolarBusinessAgriVatRate = 13.5;
export const AdditionalItemsClassification = EProductClassification.Other;
export const FeedInTariffRateHome = 0.21;
export const FeedInTariffRateFarmBusiness = 0.12;
export const FeedInTariffToken = "{feed_in_tariff}";
export const DepositBoiler = 99;
export const DepositSolarDomestic = 500;
export const DepositSolarNonDomestic = 1000;
export const DepositDefault = 99;
export const DepositAmountToken = "{deposit_amount}";

export const FeatureEnabled = "true";
export const FeatureAddons = "Swyft.AddOn";
export const FeaturePaymentDeposit = "Swyft.PaymentDeposit";
export const FeaturePaymentBalance = "Swyft.PaymentBalance";
export const FeatureLuckyOrange = "Swyft.LuckyOrange";
export const FeatureTermly = "Swyft.Termly";
export const FeatureGtm = "Swyft.Gtm";
export const FeatureProveSrc = "Swyft.ProveSrc";
export const FeatureSchedule = "Swyft.Schedule";
export const FeatureDiscount = "Swyft.Discount";

export const FeatureConfigLuckyOrangeSiteId = "LuckyOrangeSiteId";
export const FeatureConfigStripeKey = "StripeKey";
export const FeatureConfigGtmContainerId = "GtmContainerId";

export const SubscriptionDelayInDays = 1;
export const ScheduleCategory = "Schedule";

export const QuoteAssumptions = [
  "The cost of electricity will increase by 3% per annum.",
  "The cost per electricity is 35c/kWh (unless your information was provided).",
  "The feed-in tarriff is {feed_in_tariff}c/kWh.",
  "Calculations are based on on A PSO levy of €45.25 and an estimated annual standing charge of €250",
  "When a battery is present, the results include additional savings from charging your battery at a cheaper night rate, which will further reduce your electricity bill and lower your payback period time.",
  "The performance of solar PV system is impossible to predict with certainty due to the variability in the amount of solar radiation (sunlight) from location to location and from year to year. The solar output and self consumption patterns are best estimates based upon industry standard software and is given as guidance only. It should not be considered as a guarantee of performance."
];

export const LeadAssumptions = [
  "The orientation of the system is south.",
  "The cost of electricity will increase by 3% per annum.",
  "The cost per electricity is 35c/kWh.",
  "Calculations are based on on A PSO levy of €45.25 and an estimated annual standing charge of €250",
  "When a battery is present, the results include additional savings from charging your battery at a cheaper night rate, which will further reduce your electricity bill and lower your payback period time.",
  "The performance of solar PV system is impossible to predict with certainty due to the variability in the amount of solar radiation (sunlight) from location to location and from year to year. The solar output and self consumption patterns are best estimates based upon industry standard software and is given as guidance only. It should not be considered as a guarantee of performance."
];

export const LeadAssumptionsHomeFarm = ["The slope of your roof is 40 degrees.", "The feed-in tarriff is 0.21c/kWh."];

export const LeadAssumptionsBusiness = ["The slope of your roof is 15 degrees.", "The feed-in tarriff is 0.12c/kWh."];
